import * as tslib_1 from "tslib";
import React from 'react';
var DummyFullView = /** @class */ (function (_super) {
    tslib_1.__extends(DummyFullView, _super);
    function DummyFullView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DummyFullView.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: '100%',
                height: '75vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement("h1", null,
                "JUST A DUMB DUMMY VIEW: ",
                this.props.type)));
    };
    return DummyFullView;
}(React.Component));
export { DummyFullView };
export default DummyFullView;
//# sourceMappingURL=Dummy.js.map